import { styled } from '@mui/material/styles'
import Link, { LinkProps } from '@mui/material/Link'

const StyledLink = styled(Link)<LinkProps>(({ theme }) => ({
  '&.MuiLink-button': {
    boxSizing: 'border-box',
    fontWeight: 500,
    lineHeight: 1,
    textTransform: 'none',
    borderRadius: '0.4rem',
    fontSize: '1.4rem',
    padding: '1.6rem 2.8rem',
    maxHeight: '4.8rem',
    border: '2px solid',
    boxShadow: 'none',
  },
}))

export default StyledLink
